import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d4d4e17&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d4d4e17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d4e17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4d4e17')) {
      api.createRecord('2d4d4e17', component.options)
    } else {
      api.reload('2d4d4e17', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d4d4e17&scoped=true&", function () {
      api.rerender('2d4d4e17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/court/courtSchedule/index.vue"
export default component.exports